<template>
  <div class="interaction-attachments">
    <div
      v-if="attachments && attachments.length"
      class="my-2"
    >
      <v-item-group multiple>
        <v-item
          v-for="attachment in attachments"
          :key="attachment.key"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-chip
                  slot-scope="{ hover }"
                  v-on="on"
                  :color="hover ? 'grey lighten-1' : 'grey lighten-2'"
                  class="playposit-attachment-chip leading-button-chip no-focus-chip pointer"
                  @click="attachment.status === 'ready' ? downloadAttachment(attachment) : null"
                  @keydown.enter="attachment.status === 'ready' ? downloadAttachment(attachment) : null"
                  @keydown.space="attachment.status === 'ready' ? downloadAttachment(attachment) : null"
                  :aria-label="`Press enter or space to download the following attachment: ${attachment.name}`"
                >
                  <v-progress-circular
                    v-if="attachment.status === 'processing'"
                    class="mr-2 leading"
                    indeterminate
                    :size="20"
                    :width="2"
                  ></v-progress-circular>
                  <v-icon
                    v-else
                    class="mr-2 leading"
                    :color="hover ? null : 'grey darken-1'"
                    size="20"
                  >
                    description
                  </v-icon>
                  <span class="grey--text text--darken-3">
                    {{attachment.name.truncate(20, {
                      position: 'center',
                      isFilename: true,
                    })}}
                  </span>
                </v-chip>
              </v-hover>
            </template>
            <span class="white--text">Download {{attachment.name}}</span>
          </v-tooltip>
        </v-item>
      </v-item-group>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InteractionAttachments',
  props: {
    attachments: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    downloadAttachment(attachment) {
      window.open(`${attachment.url}?bcdn_filename=${encodeURIComponent(attachment.name)}`);
    },
  },
};
</script>